var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "new-carrier__box" },
    [
      _c("sc-icon", { attrs: { icon: "box-open" } }),
      _vm._v(" "),
      _c("p", { staticClass: "new-carrier__title" }, [
        _vm._v("Não encontrou a transportadora?")
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Preencha o formulário para nossa equipe te ajudar na integração"
        )
      ]),
      _vm._v(" "),
      _c("sc-button", {
        staticClass: "new-carrier__button",
        attrs: {
          text: "Adicionar nova transportadora",
          theme: "primary",
          type: "button"
        },
        on: {
          click: function($event) {
            _vm.openForm()
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-35e56b38", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35e56b38","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-integrations/features/integrations-app-self-service/components/app-list/btn-add-new-carrier/BtnAddNewCarrier.vue
// module id = null
// module chunks = 